import { CollectionEntity } from "@busy-human/gearbox";
export var Bookings;
(function (Bookings) {
    function Default() {
        return {
            tripId: '',
            bookingOwner: '',
            bookedAt: new Date().toISOString(),
            isDepositPaid: false,
            isFullyPaid: false,
            builders: [],
            remainingBalance: 0,
            totalPaid: 0,
            builderRoles: {}
        };
    }
    Bookings.Default = Default;
    // We are not including a Validate function, as this collection should not be user writeable
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
        async getBookingsForBuilder(ref) {
            const id = typeof ref === 'string' ? ref : ref.$id;
            return (await this.subset((r, query) => query.where('builders', 'array-contains', id).toQuery()).fetch()).map(d => d.data());
        }
        /**
         * Gets list of bookings owner by a firebase user
         * @param userId Firebase Auth userid
         * @returns array of bookings owned by user
         */
        async getBookingsOwnedByUser(userId) {
            return (await this.subset((ref, query) => query.where('bookingOwner', '==', userId).toQuery()).fetch()).map(d => d.data());
        }
    }
    Bookings.CollectionClass = CollectionClass;
    Bookings.Collection = new CollectionClass({ path: '/Bookings' });
})(Bookings || (Bookings = {}));
//# sourceMappingURL=index.js.map